<div class="downloadsPage" *ngIf="('ControlDescargas' | permissionFilter)">
  <div class="container-component">
        <downloads-list class="role-list"></downloads-list>
    </div>
</div>
<div *ngIf="!('ControlDescargas' | permissionFilter) ">
  <br><br><br><br>
  <h1 class="error">User not Authorized to enter this page</h1>
</div>